import _ from 'lodash';

import { extractReprocessMealsModel } from '../../helpers/hub';

const root = (state) => _.get(state, 'ManageApplicationState.hub');

export const getOriginalStatusCurrent = (state) =>
  _.get(root(state), 'originalStatusCurrent');

export const getOriginalStatusFuture = (state) =>
  _.get(root(state), 'originalStatusFuture');

export const getHasReimbursableMeals = (state) =>
  _.get(root(state), 'hasReimbursableMeals');

export const getReprocessMealsModel = (state) => {
  const application = _.get(root(state), 'tempApplication');
  return extractReprocessMealsModel(application);
};

export const getDbApplication = (state) =>
  _.get(root(state), 'getDbApplication');

export const getShowItemMappingModal = (state) =>
  _.get(root(state), 'showItemMappingModal');

export const getReprocessingMealsLoading = (state) =>
  _.get(root(state), 'reprocessingMealsLoading');

export const getReprocessSuccessful = (state) =>
  _.get(root(state), 'reprocessSuccessful');

export const getIsDuplicateApp = (state) =>
  _.get(root(state), 'isDuplicateApp', false);



// WEBPACK FOOTER //
// ./src/pages/manageapplication/state/hub/selectors.js